import { useCallback, useEffect, useRef, useState } from 'react'
import { clearOidcReauthorization, loadSession } from '../../auth/state'
import { createProgressPoller } from './poller'

export function useProgress() {
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [syncedAt, setSyncedAt] = useState(null)
  const [now, setNow] = useState(Date.now())
  const poller = useRef(null)

  useEffect(() => {
    const instance = createProgressPoller({
      getSession: loadSession,
      onLoading: setLoading,
      onError: setError,
      onData: (next) => {
        clearOidcReauthorization()
        setData(next)
        setError('')
        setSyncedAt(Date.now())
        setNow(Date.now())
      },
    })
    poller.current = instance
    const clock = window.setInterval(() => {
      if (!document.hidden) setNow(Date.now())
    }, 10_000)
    return () => {
      instance.stop()
      poller.current = null
      window.clearInterval(clock)
    }
  }, [])

  const refresh = useCallback(() => poller.current?.refresh(), [])
  return { data, error, loading, syncedAt, now, refresh }
}
